<template>
<div class="mx-auto" width="400px" >
    <v-date-picker readonly full-width></v-date-picker>
</div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>